import React, { useState } from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Button, CircularProgress } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
async function toBase64(url) {
  const res  = await fetch(url);
  const blob = await res.blob();
  
  // [FIX] เช็ค content-type ก่อน — ถ้าไม่ใช่ image ให้ return ""
  if (!blob.type.startsWith("image/")) {
    console.warn("ไม่ใช่ไฟล์รูป:", blob.type);
    return "";
  }

  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
}


async function renderToPDF(htmlContent) {
  const container = document.createElement("div");
  container.style.cssText = `
    position: fixed;
    top: -9999px;
    left: -9999px;
    width: 794px;
    background: white;
    font-family: 'Sarabun', 'THSarabunNew', sans-serif;
    font-size: 13px;
    color: #000;
    padding: 0;
  `;
  container.innerHTML = htmlContent;
  document.body.appendChild(container);

  const pdf      = new jsPDF({ unit: "mm", format: "a4", orientation: "portrait" });
  const margin   = 15;
  const contentW = 210 - margin * 2;

  const pages = container.querySelectorAll(".pdf-page");
  for (let i = 0; i < pages.length; i++) {
    const canvas = await html2canvas(pages[i], {
      scale: 2,
      useCORS: true,
      backgroundColor: "#ffffff",
    });
    const imgData = canvas.toDataURL("image/png");
    const imgH    = (canvas.height * contentW) / canvas.width;
    if (i > 0) pdf.addPage();
    pdf.addImage(imgData, "PNG", margin, margin, contentW, imgH);
  }

  document.body.removeChild(container);
  return pdf;
}

const row = (label, value, half = false) => `
  <div style="display:${half ? "inline-block" : "block"};width:${half ? "48%" : "100%"};margin-bottom:5px;">
    <span style="font-weight:600;">${label}${label ? ":" : ""}</span>
    <span style="border-bottom:1px solid #000;display:inline-block;min-width:120px;padding-left:4px;">
      ${value ?? ""}
    </span>
  </div>`;

const rowHalf = (label, value) => row(label, value, true);

const sectionTitle = (title) => `
  <div style="font-weight:700;font-size:14px;margin:14px 0 4px;border-bottom:1px solid #000;padding-bottom:2px;">
    ${title}
  </div>`;

const checkBox = (checked) =>
  `<span style="display:inline-block;width:12px;height:12px;border:1px solid #000;
   text-align:center;line-height:12px;font-size:10px;margin-right:4px;">
   ${checked ? "✓" : ""}</span>`;

// ── [FIX] buildHTML รับ logoBase64 เป็น parameter ───────────────────────
function buildHTML(form, files, logoBase64 = "") {

  const page1 = `
<div class="pdf-page" style="padding:20px 30px;min-height:1050px;">

  <table style="width:100%;margin-bottom:10px;">
    <tr>
      <td style="vertical-align:middle;width:120px;">
        ${logoBase64 ? `<img src="${logoBase64}" alt="Logo" style="width:100px;" />` : ""}
      </td>
      <td style="vertical-align:top;text-align:right;">
        <div style="font-weight:700;font-size:15px;">SINO Logistics Corporation PLC</div>
        <div style="font-size:11px;">1011 Supalai Grand Tower 7th Floor Unit 05, Rama 3 Road,</div>
        <div style="font-size:11px;">Chongnonsee, Yannawa, Bangkok, 10120 Thailand</div>
        <div style="font-size:11px;">บริษัท ไซโน โลจิสติกส์คอร์ปอเรชั่น จำกัด (มหาชน)</div>
        <div style="font-size:11px;">1011 อาคารศุภาลัยแกรนด์ ทาวเวอร์ ชั้น 7 ยูนิต 05</div>
          <div style="font-size:11px;">ถนนพระรามสาม แขวงช่องนนทรี เขตยานนาวา กทม. 10120</div>
      </td>
    </tr>
  </table>

  <div style="text-align:center;font-weight:700;font-size:16px;margin:8px 0 12px;">
    แบบฟอร์มการเปิดลูกค้าใหม่/ขอเครดิต และขอเพิ่มวงเงิน
  </div>

  <div style="text-align:right;margin-bottom:10px;">
    <div style="font-size:11px;">วันที่ <span style="border-bottom:1px solid #000;display:inline-block;min-width:120px;padding-left:4px;">${form.createDate ?? ""}</span></div>
    <div style="font-size:11px;margin-top:6px;">รหัสลูกค้า <span style="border-bottom:1px solid #000;display:inline-block;min-width:100px;padding-left:4px;">${form.customerCode ?? ""}</span></div>
  </div>

  <table style="width:100%;margin-bottom:8px;">
    <tr>
      <td>
        ${checkBox(form.requestType === "new")} เปิดลูกค้าใหม่
        &nbsp;&nbsp;&nbsp;
        ${checkBox(form.requestType === "increase")} ขอวงเงินเพิ่ม / จำนวนวันเครดิต
      </td>
    </tr>
    <tr>
      <td style="padding-top:4px;">
        ${checkBox(form.paymentType === "cash")} CASH &nbsp;&nbsp;
        ${checkBox(form.paymentType === "credit")} CREDIT
      </td>
    </tr>
    <tr>
      <td style="padding-top:4px;">
        ${checkBox(form.channel === "PP")} PP &nbsp;&nbsp;
        ${checkBox(form.channel === "CC")} CC &nbsp;&nbsp;
        Agent Name <span style="border-bottom:1px solid #000;display:inline-block;min-width:100px;">${form.agentName ?? ""}</span> &nbsp;&nbsp;
        ${checkBox(form.channel === "PC")} PC/CP
      </td>
    </tr>
    <tr>
      <td style="padding-top:4px;">
        ${checkBox(!!form.otherType)} Others
        <span style="border-bottom:1px solid #000;display:inline-block;min-width:120px;">${form.otherType ?? ""}</span>
      </td>
    </tr>
  </table>

  ${sectionTitle("ข้อมูลทั่วไป")}
  ${row("ชื่อลูกค้า (ภาษาไทย)", form.nameTH)}
  ${row("ชื่อลูกค้า (ภาษาอังกฤษ)", form.nameEN)}
  ${row("ที่อยู่ในการออกใบกำกับภาษี", [form.address1, form.address2, form.address3, form.address4].filter(Boolean).join(" "))}
  ${row("", [form.subdistrict, form.district, form.city, form.postalCode, form.country].filter(Boolean).join(" "))}
  <div style="margin-bottom:5px;">
    ${rowHalf("โทรศัพท์", form.tel)}
    ${rowHalf("ต่อ", form.ext)}
  </div>
  <div style="margin-bottom:5px;">
    ${rowHalf("โทรสาร", form.fax)}
    ${rowHalf("มือถือ", form.mobile)}
  </div>
  <div style="margin-bottom:5px;">
    ${rowHalf("Email", form.email)}
    ${rowHalf("Contact Person", form.contactPerson)}
  </div>
  <div style="margin-bottom:5px;">
    ${rowHalf("Contact Person (Finance/Accounting)", form.contactFinance)}
    ${rowHalf("โทรศัพท์", form.financeTel)}
  </div>
  ${row("เลขประจำตัวผู้เสียภาษี", form.taxId)}
  ${row("Tax Classification", form.taxClassification)}
  ${row("ประเภทธุรกิจ", form.businessType)}
  ${row("วันที่จดทะเบียน", form.registerDate)}
  ${row("ทุนจดทะเบียน (บาท)", form.registeredCapital)}
  ${row("ทุนจดทะเบียนชำระแล้ว (บาท)", form.paidUpCapital)}
  <div style="font-size:11px;color:#333;margin-top:6px;">
    ** สำหรับกรณีการเปิดบัญชีลูกค้างานทั่วไปที่ไม่ใช่ "Freight" ไม่มีเครดิตเทอม (Cash)
    จัดทำแบบฟอร์มเฉพาะส่วนข้อมูลทั่วไปโดยที่ไม่ต้องมีเอกสารประกอบการขอเครดิต
  </div>

  ${sectionTitle("ข้อมูลด้านบัญชี")}
  ${row("ปีที่รายงาน", form.reportYear)}
  <div style="margin-bottom:5px;">
    ${rowHalf("ยอดขายสุทธิ (บาท)", form.netSales)}
    ${rowHalf("กำไรสุทธิ (บาท)", form.netProfit)}
  </div>
  <div style="margin-bottom:5px;">
    ${rowHalf("สินทรัพย์ถาวร (บาท)", form.fixedAssets)}
    ${rowHalf("สินทรัพย์หมุนเวียน (บาท)", form.currentAssets)}
  </div>
  <div style="margin-bottom:5px;">
    ${rowHalf("หนี้สินรวม (บาท)", form.totalLiabilities)}
    ${rowHalf("ส่วนของผู้ถือหุ้น (บาท)", form.shareholderEquity)}
  </div>
  <div style="font-size:11px;font-weight:600;margin-top:4px;">
    หมายเหตุ กรุณาแนบงบการเงินย้อนหลัง 3 ปี
  </div>

</div>`;

  const fileList = (docKey, label) => {
    const arr = files?.[docKey] || [];
    return `<div style="margin-bottom:4px;">${checkBox(arr.length > 0)} ${label}</div>`;
  };

  const page2 = `
<div class="pdf-page" style="padding:20px 30px;min-height:1050px;">

  <table style="width:100%;margin-bottom:10px;">
    <tr>
      <td style="vertical-align:middle;width:120px;">
        ${logoBase64 ? `<img src="${logoBase64}" alt="Logo" style="width:100px;" />` : ""}
      </td>
      <td style="vertical-align:top;text-align:right;">
        <div style="font-weight:700;font-size:14px;">SINO Logistics Corporation PLC</div>
        <div style="font-size:10px;">FM-AC-001 Rev.00, Effective Date: 11-08-2023</div>
      </td>
    </tr>
  </table>

  ${sectionTitle("วงเงินเครดิตที่ต้องการขอ")}
  ${row("ประมาณการยอดขายต่อเดือน (บาท)", form.creditMonthlySales)}
  ${row("วงเงินเครดิตที่ต้องการขอ (บาท)", form.creditLimitRequest)}
  ${row("จำนวนวันที่ต้องการขอเครดิต (วัน)", form.creditTermRequest)}
  <div style="font-size:11px;margin:6px 0;">
    วงเงินเครดิต ไม่เกินทุนจดทะเบียนของบริษัท ผู้ร้องขอเครดิต
    (กรณีต้องการมากกว่าทุนจดทะเบียน ต้องยื่นเรื่องขออนุมัติจากผู้มีอำนาจตามที่บริษัทฯกำหนด)
  </div>
  <div style="font-weight:700;font-size:12px;margin-bottom:10px;">***กรุณายื่นเอกสารก่อนลูกค้าคืนตู้***</div>

  ${sectionTitle("เงื่อนไขการรับวางบิลและจ่ายเช็ค")}
  <div style="margin-bottom:6px;">
    การนับเครดิต :
    &nbsp;${checkBox(form.creditCountFrom === "invoice_date")} นับจากวันที่ในใบส่งของ/Invoice
    &nbsp;${checkBox(form.creditCountFrom === "billing_date")} นับจากวันที่รับวางบิล
    &nbsp;${checkBox(form.creditCountFrom === "other")} อื่นๆ
  </div>
  <div style="margin-bottom:6px;">
    กำหนดการจ่ายชำระเงิน :
    &nbsp;${checkBox(form.paymentMethod === "cheque")} จ่ายเป็นเช็ค
    &nbsp;${checkBox(form.paymentMethod === "transfer")} โอนเงินเข้าบัญชี
  </div>
  ${row("กำหนดการจ่ายเช็ค/โอนเงิน ทุกวันที่", form.paymentDay)}

  ${sectionTitle("เอกสารประกอบการขอเครดิต")}
  ${fileList("doc_company_cert",        "หนังสือรับรองบริษัท มีอายุไม่เกิน 3 เดือน")}
  ${fileList("doc_financial_statement", "งบแสดงฐานะการเงิน / งบกำไรขาดทุน / อัตราส่วนทางการเงิน (DBD)")}
  ${fileList("doc_vat20",               "สำเนา ภ.พ.20 (ในกรณีที่จดทะเบียนภาษีมูลค่าเพิ่ม)")}
  ${fileList("doc_delivery_schedule",   "กำหนดการรับส่งสินค้า / รับวางบิล / จ่ายเช็ค (ถ้ามี)")}
  ${fileList("doc_company_map",         "แผนที่ตั้งบริษัทของท่าน และแผนที่รับเช็ค")}
  ${fileList("doc_company_photo",       "ภาพถ่ายสถานประกอบการ")}

  <div style="margin-top:60px;text-align:right;">
    <div>ลงชื่อ ........................................................ผู้ขอเครดิต</div>
    <div style="margin-top:8px;">( ........................................................ )</div>
    <div style="margin-top:8px;">ตำแหน่ง .......................................................</div>
    <div style="margin-top:8px;">วันที่ .............................................................</div>
  </div>

</div>`;

  return page1 + page2;
}

// ── [FIX] await toBase64 อยู่ใน async function เท่านั้น ─────────────────
export async function exportCustomerPDF(form, files) {
// [FIX] ใช้ %PUBLIC_URL% path — ไฟล์ต้องอยู่ใน public/
  const logoBase64 = await toBase64(process.env.PUBLIC_URL + "/sino-logo.png");
  const html       = buildHTML(form, files, logoBase64);
  const pdf        = await renderToPDF(html);
  const filename   = `customer_register_${form.customerCode || "new"}_${new Date().toISOString().split("T")[0]}.pdf`;
  pdf.save(filename);
}

export function ExportPDFButton({ form, files }) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      await exportCustomerPDF(form, files);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outlined"
      color="error"
      startIcon={loading ? <CircularProgress size={16} /> : <PictureAsPdfIcon />}
      onClick={handleClick}
      disabled={loading}
    >
      {loading ? "กำลังสร้าง PDF..." : "Export PDF"}
    </Button>
  );
}
